export const getLastWord = name => {
  const newResult = name?.substr(name?.lastIndexOf('.') + 1);
  return newResult?.toLowerCase();
};
